const safeParse = (value) => {
  try {
    return value ? JSON.parse(value) : null;
  } catch {
    return null;
  }
};

/**
 * Lê contexto do usuário/unidade a partir do localStorage do SGU.
 * Não envia PII (e-mail/nome) — apenas IDs.
 */
export const getAnalyticsContext = () => {
  const user = safeParse(localStorage.getItem("user")) || {};
  const cooperative = safeParse(localStorage.getItem("cooperative")) || {};

  const companyId =
    cooperative?.companyId ||
    cooperative?.empresaId ||
    user?.companyId ||
    null;

  const unitId = cooperative?._id || null;

  return {
    companyId: companyId ? String(companyId) : null,
    unitId: unitId ? String(unitId) : null,
  };
};
